import { useEffect, useState } from 'react';
import Button from 'src/components/Button';
import Input from 'src/components/Input';
import { completeSetupMFA, setupMFA } from 'src/services/api/MFA/mfa';
import { ModeTile } from './ModeTile';

import Icon from 'src/components/Icon/FontAwesomeIcon';
import { TotpQRCode } from './TotpQRCode';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';

export const MFASignupForm = () => {
  const [mode, setMode] = useState<'email' | 'totp'>('email');
  const [step, setStep] = useState<'mode' | 'verify'>('mode');

  const user = useSelector(selectAuthenticatedUser);

  return (
    !user.mfaEnabled && (
      <div className="settings__section" style={{ paddingBottom: '5rem' }}>
        <h3 className="form__heading">Multifactor Authentication</h3>
        <div>
          {(() => {
            switch (step) {
              case 'mode':
                return (
                  <Mode
                    setMode={(mode) => {
                      setMode(mode);
                      setStep('verify');
                    }}
                  />
                );
              case 'verify':
                return <VerifyMfa mode={mode} setStep={setStep} />;
            }
          })()}
        </div>
      </div>
    )
  );
};

export const Mode = ({ setMode }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
    <ModeTile
      label="Email"
      icon={<Icon glyph="envelope" size="medium" weight="light" />}
      onClick={() => setMode('email')}
    />

    <ModeTile
      label="Authenticator App"
      icon={<Icon glyph="mobile-alt" size="medium" weight="light" />}
      onClick={() => setMode('totp')}
    />
  </div>
);

export const VerifyMfa = ({ mode, setStep }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const userId = user?.id;

  const [code, setCode] = useState('');
  const [totpUrl, setTotpUrl] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    setupMFA(userId, mode).then(async (response) => {
      if (!(response instanceof Response)) return;
      const res = await response.json();
      if (mode === 'totp') {
        setTotpUrl(res.data);
      }
    });
  }, []);

  const confirmMfa = async () => {
    const response = await completeSetupMFA(userId, mode, code);
    if (!(response instanceof Response)) return;

    if (response.status === 200) {
      alert('MFA setup completed successfully!');
      setStep('mode');
    } else {
      alert('MFA setup failed. Please try again.');
      setStep('mode');
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          position: 'absolute',
          left: '1rem',
          top: '0rem',
          cursor: 'pointer',
        }}
        onClick={() => setStep('mode')}
      >
        <Icon glyph="arrow-left" size={'medium'} weight={'solid'} />
      </div>

      {mode === 'email' && (
        <>
          <h3>Check your email to continue:</h3>
          <p>
            A verification code has been sent to your email address. Please
            check your inbox (and spam folder) and enter the code to continue.
          </p>
        </>
      )}
      {mode === 'totp' && (
        <>
          <h3>Scan the QR code to continue:</h3>
          <p>
            Use your authenticator app to scan the QR code and enter the code to
            continue.
          </p>

          <TotpQRCode value={totpUrl} />
        </>
      )}

      <Input
        label="Verification Code"
        placeholder="Enter your verification code"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        block
      />
      <Button onClick={() => confirmMfa()} size="small" color="teal">
        Submit
      </Button>
    </div>
  );
};
